import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../../core/auth/auth.service';
import { UserService } from '../../../../core/user.service';
import * as Chart from "chart.js";

@Component({
  selector: 'app-cqmns-app-rating',
  templateUrl: './cqmns-app-rating.component.html',
  styleUrls: ['./cqmns-app-rating.component.css']
})
export class CqmnsAppRatingComponent implements OnInit {
  projectId: any;
  value1: any;
  hostUrl;
  ctxapprate: any;
  canvasapprate: any;
  myChartapprate: any;
  ctxappRate1: any;
  appRating:any;
  playRating :any;
  myTrendapp: any;
  canvasazurecpu: any;
  ctxazurecpu: any;
  myChartazurecpu: any;
  fromTime: any;
  NowDate: any;
  isoDate: any;
  toTime: any;
  dt: any;
  month: any;
  year: number;
  date: string;
 configPlay: any;
  appname: any;
  userId: any;
  constructor(private http: HttpClient,
    private route: ActivatedRoute, private authService: AuthService, 
    private userService: UserService) { }

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hostUrl = this.userService.getUrl();
    this.userId = localStorage.getItem("userid");

  //  this.projectId = this.route.snapshot.params["projectId"];
  this.projectId = localStorage.getItem("projectId");
    this.value1 = "val01"
    this.onchangeAppRating(this.value1)
 this.http.get(encodeURI(this.hostUrl+'/configure/playConfig/' + this.projectId))
    .subscribe(data => {
    this.configPlay = data;
    this.appname = this.configPlay.APP_ID;
});
  }
  onchangeAppRating(value1) {
    var s = new Date();
    this.year = s.getFullYear();
    this.month = s.getMonth()+1;
    this.dt = s.getDate();
    if (this.dt < 10) {
     this.dt = '0' + this.dt;
    }
   if (this.month < 10) {
   this.month = '0' + this.month;
    }
    this.fromTime = this.year+'-' + this.month + '-' + this.dt;
    this.value1 = value1;
    if (this.value1 === "val01") {
    s.setMinutes(s.getMinutes() - 10080);
    this.isoDate = new Date(s);
    this.year = s.getFullYear();
    this.month = s.getMonth()+1;
    this.dt = s.getDate();
    if (this.dt < 10) {
     this.dt = '0' + this.dt;
    }
   if (this.month < 10) {
   this.month = '0' + this.month;
    }
    this.toTime = this.year+'-' + this.month + '-' + this.dt;
    } else if (this.value1 === "val06") {
    s.setMinutes(s.getMinutes() - 40320);
    this.isoDate = new Date(s);
    this.year = s.getFullYear();
    this.month = s.getMonth()+1;
    this.dt = s.getDate();
    if (this.dt < 10) {
     this.dt = '0' + this.dt;
    }
   if (this.month < 10) {
   this.month = '0' + this.month;
    }
    this.toTime = this.year+'-' + this.month + '-' + this.dt;
    } else if (this.value1 === "val12") {
    s.setMinutes(s.getMinutes() - 129600);
    this.isoDate = new Date(s);
    this.year = s.getFullYear();
    this.month = s.getMonth()+1;
    this.dt = s.getDate();
    if (this.dt < 10) {
     this.dt = '0' + this.dt;
    }
   if (this.month < 10) {
   this.month = '0' + this.month;
    }
    this.toTime = this.year+'-' + this.month + '-' + this.dt;
    } 
        this.http
      .get(
        encodeURI(
          this.hostUrl + '/api/issue/appRatingPlayStore/' + this.projectId + '/' + this.toTime + '/' +this.fromTime
        )
      )
      .subscribe(data => {
        this.playRating  = data;
      });
      this.http
      .get(
        encodeURI(
          this.hostUrl + '/api/issue/appRatingAppStore/' + this.projectId + '/' + this.toTime + '/' +this.fromTime
        )
      )
      .subscribe(data => {
        this.appRating = data;
        this.updateAppRate(); 
        this.updateChartAppRate(this.myChartazurecpu)
      });
   }
 
  updateAppRate() {
    this.canvasazurecpu = document.getElementById("myChartazurecpu");
    this.ctxazurecpu = this.canvasazurecpu.getContext("2d");
    this.myChartazurecpu = new Chart(this.ctxazurecpu, {
      type: "line",
      data: {
        labels: [],
        datasets: [{
          label: 'App Store',
          data: [],
          backgroundColor: 'rgba(0, 161, 241,0.4)',
          fill: false,
          borderColor: 'rgba(0, 161, 241,0.4)',
        }, {
          label: 'Play Store',
          data: [],
          backgroundColor: 'rgba(234, 68, 53,0.4)',
          borderColor: 'rgba(234, 68, 53,0.4)',
          fill: false,
        }]
      },
      options: {
        spanGaps: true,
        responsive: true,
        // title: {
        //   display: true,
        //   text: 'Chart Title'
        // },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          xAxes: [{
            display: true,
            type: "time",
         time: {
           parser: "YYYYMMDD",
           unit: "day",
           
           tooltipFormat: "MMM DD YYYY",
           displayFormats: {
             day: "MMM DD"
           }
          },
            scaleLabel: {
              display: true,
              labelString: 'Day'
            }
           
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              labelString: 'Rating',
              display: true,

            },
            ticks: {
              min: 1,
              max: 5,
    
            }
          }]
        }
      }
    });
  
  }
  updateChartAppRate(myTrendsum) {
    for (let i = 0; i < this.appRating.length; i++) {
      myTrendsum.data.labels.push(this.appRating[i].date);
      myTrendsum.data.datasets[0].data.push(this.appRating[i].avg_rating);
      myTrendsum.data.datasets[1].data.push(this.playRating[i].avg_rating);

    }
    myTrendsum.update();
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-defect/cqmns-app-rating/cqmns-app-rating.component.ts